module.exports = __webpack_public_path__ + "media/pages/book/components/images/app-reviews/de/anja-a36503baed9640449de6491875604043.jpg";